 import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TeamComponent } from './team/team.component';
import { NavigationComponent } from './navigation/navigation.component';
import { FooterComponent } from './footer/footer.component';
import { ContactComponent } from './contact/contact.component';

import { EventComponent } from './event/event.component';
import { ServiceComponent } from './service/service.component';
import { ProcessComponent } from './process/process.component';
import { IntroComponent } from './intro/intro.component';
import { VideoComponent } from './video/video.component';
import { LoadingComponent } from './loading/loading.component';
import { SiteComponent } from './site/site.component';
import { TechComponent } from './tech/tech.component';
import { Video2Component } from './video2/video2.component';

@NgModule({
  declarations: [
    AppComponent,
    TeamComponent,
    NavigationComponent,
    FooterComponent,
    ContactComponent,
    EventComponent,
    ServiceComponent,
    ProcessComponent,
    IntroComponent,
    VideoComponent,
    LoadingComponent,
    SiteComponent,
    TechComponent,
    Video2Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
